import { createFileRoute } from '@tanstack/react-router';
import AppLayout from '@/layouts/AppLayout.tsx';

export const Route = createFileRoute('/_manager/_app')({
  component: AppLayout,
});
